import { Nilable } from "../shared/utils/Nullable";

export interface ICoordenadasDTO {
    latitude: number;
    longitude: number;
}

export class CoordenadasDTO {
    public latitud = 0;
    public longitud = 0;

    constructor(json: Nilable<Partial<ICoordenadasDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICoordenadasDTO>) {
        if (json.longitude != null) {
            this.longitud = json.longitude;
        }
        if (json.latitude != null) {
            this.latitud = json.latitude;
        }
    }

    public toJSON(): ICoordenadasDTO {
        return {
            latitude: this.latitud,
            longitude: this.longitud
        };
    }
}
